function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.952462, 0, 0, 2.952462, -488.114349, -488.11557)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(229, 26, 148)"
    },
    cx: 250,
    cy: 250,
    r: 50,
    transform: "matrix(0.728802, -0.684724, 0.684724, 0.728802, -103.381929, 238.980512)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(194, 25, 126)"
    },
    transform: "matrix(-0.112651, -0.119903, 0.119905, -0.112648, 270.356598, 387.33725)",
    d: "M 693.245 785.328 A 303.915 303.915 0 0 1 693.074 177.498 L 693.192 481.413 Z",
    bxShape: "pie 693.192 481.413 0 303.915 179.99 359.978 1@c3a8fa60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.226,
    y: 48.297,
    width: 13.852,
    height: 24.79,
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(0.727474, -0.686135, 0.686135, 0.727474, -70.591103, 470.965607)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.274,
    y: 119.419,
    width: 15.017,
    height: 61.292,
    style: {
      fill: "rgb(213, 213, 213)"
    },
    transform: "matrix(0.68593, 0.727668, -0.727668, 0.68593, 95.795746, -136.836121)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(192, 60, 60)",
      fill: "rgb(255, 255, 255)"
    },
    d: "M 212.466 253.342 L 231.028 249.577 L 230.71 266.359",
    transform: "matrix(0.981724, 0.190309, -0.190309, 0.981724, 53.14624, -37.485896)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconPink);
export default __webpack_public_path__ + "static/media/tickIconPink.5a392f3eb50781fe3dfed0509c2760bc.svg";
export { ForwardRef as ReactComponent };